var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "var(--fill-0, black)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lightbulb_100dp_FFFFFF_FILL0_wght400_GRAD0_opsz48 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5312 22.8438C16.8576 22.5174 17.0208 22.1181 17.0208 21.6458H13.6458C13.6458 22.1181 13.8089 22.5174 14.1353 22.8438C14.4617 23.1701 14.861 23.3333 15.3333 23.3333C15.8055 23.3333 16.2048 23.1701 16.5312 22.8438ZM18.7083 20.3542V19.1042H11.9583V20.3542H18.7083ZM18.6041 17.8333C19.5208 17.2361 20.2464 16.4896 20.7812 15.5938C21.3159 14.6979 21.5833 13.6875 21.5833 12.5625C21.5833 10.8681 20.9652 9.40278 19.7291 8.16667C18.493 6.93056 17.0277 6.3125 15.3333 6.3125C13.6388 6.3125 12.1735 6.93056 10.9374 8.16667C9.70131 9.40278 9.08325 10.8681 9.08325 12.5625C9.08325 13.6875 9.34714 14.6979 9.87492 15.5938C10.4027 16.4896 11.1319 17.2361 12.0624 17.8333H18.6041ZM18.1458 16.5833H12.4999C11.8333 16.1389 11.3055 15.5625 10.9166 14.8542C10.5277 14.1458 10.3333 13.3819 10.3333 12.5625C10.3333 11.1875 10.8228 10.0104 11.802 9.03125C12.7812 8.05208 13.9583 7.5625 15.3333 7.5625C16.7083 7.5625 17.8853 8.05208 18.8645 9.03125C19.8437 10.0104 20.3333 11.1875 20.3333 12.5625C20.3333 13.3819 20.1388 14.1458 19.7499 14.8542C19.361 15.5625 18.8263 16.1389 18.1458 16.5833Z",
    fill: "var(--fill-0, #4DBEF8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.81d34416dd02628a6973381d0c111207.svg";
export { ForwardRef as ReactComponent };